import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("lakou_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export const apiError = (e, fallback = "Something went wrong. Please try again.") => {
    const d = e.response?.data?.detail;
    if (!d) return e.message || fallback;
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
    return String(d);
};

export const fileUrl = (path) => (path ? (path.startsWith("http") ? path : `${API}/files/${path}`) : "");

export const downloadFile = async (path, filename) => {
    const res = await api.get(path, { responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
};
